<script>
	let version = 1.3;

	import Header from "./HeaderCC.svelte";
	import Legend from "./LegendFlexCC.svelte";
	import Feature from "./Feature.svelte";
	import Map from "./MapSvgCC.svelte";
	import Metrics from "./MetricsMenuCCTable.svelte";
	import Buttons from "./ButtonsCC.svelte";
	import Sources from "./Sources.svelte";
	import Tooltip from "./Tooltip.svelte";

	import { fade } from "svelte/transition";
	import { selectedFeature, activeFeature, activeMetric } from "./stores.js";
	import {
		geoData,
		geoDataUsa,
		getFeature,
		getFormatted,
		slugify,
	} from "./utils";

	import { feature } from "topojson";
	import { csv, json, mean, min, max, range, format, scaleLinear } from "d3";
	// import { onMount } from "svelte";
	// import map from "lodash.map";
	// import assignIn from "lodash/assignIn";
	// import { LayerCake, Svg } from "layercake";

	export let location;

	/** @type {[]} */
	let metrics;
	/** @type {{}} */
	let metricsObj = {};
	/** @type {{}} */
	let metricGroups = {};
	/** @type [{features:{geometry:[], properties:{NAME:string, id:string, AREA:number, population:number}}] */
	let geojson;
	/** @type {{features:{geometry:[], properties:{NAME:string, id:string, AREA:number, population:number}}} */
	let sources;

	let formatted;
	let value;
	let sheet = "./assets/csv/";
	// "https://docs.google.com/spreadsheets/d/e/2PACX-1vR4WHEQ9DH14o2qeZySC3NnmH2pjXzOxIMzYPX9l_T2-5zGBrR3aAB_9Z7rDaSSlm4NXlhg7-YDueD5/pub?single=true&output=csv&gid=1028270532";
	// let sheet =
	"https://docs.google.com/spreadsheets/d/e/2PACX-1vR4WHEQ9DH14o2qeZySC3NnmH2pjXzOxIMzYPX9l_T2-5zGBrR3aAB_9Z7rDaSSlm4NXlhg7-YDueD5/pub?single=true&output=csv&gid=";

	$: mapW = 100;

	// onMount(async () => {
	let promise = Promise.all([
		// topojson - USA oulines
		json("./assets/us-states-topojson.json"),

		// metrics - states
		// csv(sheet + "1028270532"),

		// metricsCsv
		// csv(sheet + "1028270532", (d, i) => {
		csv(sheet + "metrics.csv", (d, i) => {
			metricsObj[d.id] = d;
			return d;
		}),
		// metrics - usa
		// csv(sheet + "951428010"),

		// dataCsv - convert states data to object
		// csv(sheet + "1250164524"),
		csv(sheet + "data.csv"),

		// dataUsaCsv - convert USA data to object
		// csv(sheet + "328102131"),
		csv(sheet + "data-usa.csv"),
		// csv(sheet + "328102131", d => {
		// 	d.id = slugify(d.state);
		// 	d.NAME = d.state;
		// 	geoDataUsa.features[d.id] = d;
		// 	return d;
		// }),

		// sourcesCsv
		// csv(sheet + "1483065050"),
		csv(sheet + "sources.csv"),

		// all loaded
	]).then(([topojson, metricsCsv, dataCsv, dataUsaCsv, sourcesCsv]) => {
		geojson = feature(topojson, topojson.objects.collection);
		sources = sourcesCsv;

		// array to object:
		// copy   geojson.features[##]   to   geoData.features[id]
		geojson.features.forEach((feature, i) => {
			let id = slugify(feature.properties.NAME);
			geoData.features[id] = feature;
		});

		processData(dataUsaCsv, geoDataUsa);
		processData(dataCsv, geoData);

		// remove geojson.features that do not exist in geoData
		geojson.features = geojson.features.filter(f => f.formatted);

		processMetrics(metricsCsv);

		$selectedFeature = $activeFeature = getFeature();
		if (location === true) {
			// just http
			// csv("http://ip-api.com/csv/").then(data => {
			// location = slugify(data.columns[4]);
			// cors error
			// csv("https://api.ipgeolocationapi.com/geolocate").then(data => {
			// just IP
			// csv("https://api.ipify.org").then(data => {
			// requires "secret" key
			json(
				"https://api.ipdata.co?api-key=ec5c69008d54409e4464e20c6283fc1164a20ad8ffd8235d9f987cd1"
			).then(data => {
				console.log("data", data, data.region);
				location = slugify(data.region);
				if (location == "district-of-columbia") location = "maryland";
				$selectedFeature = $activeFeature = getFeature(location);
			});
		} else if (location) {
			$selectedFeature = $activeFeature = getFeature(location);
		} else {
			// $selectedFeature = $activeFeature = getFeature();
		}

		// console.log("geoData", geoData);
		// console.log("geoDataUsa", geoDataUsa);
		// console.log("geojson", geojson);

		metrics = metricsCsv;
		$activeMetric = metrics[0]; // select 1st metric
	});

	/**
	 * Convert csv array to data object
	 * @param [] sheet
	 * @param {{}} data geoData, geoDataUsa
	 */
	function processData(sheet, data) {
		sheet.forEach((d, i) => {
			d.id = slugify(d.state);
			d.NAME = d.state;
			if (!data.features[d.id]) data.features[d.id] = {};
			data.features[d.id].properties = d;
			data.features[d.id].formatted = {};

			// loop through values
			for (let key in d) {
				let value = d[key];
				var metric = metricsObj[key];

				// if value !string convert to number
				if (Number(value)) {
					value = Number(value);
					d[key] = value;

					// formatted value
					let formatted = metric.format
						? format(metric.format)(value)
						: getFormatted(value);
					// data.formatted[d.id][key] =
					data.features[d.id].formatted[key] =
						metric.prefix + formatted + metric.suffix;
				}
			}
		});
	}

	function processMetrics(metricsCsv) {
		// min, max, mean, and groups
		metricsCsv.forEach((metric, i) => {
			// metricsObj[metric.id] = metric;

			// direction of extent
			metric.direction = metric.direction
				.trim()
				.substr(0, 1)
				.toLowerCase();

			// min, max, mean values for all states - entire USA
			metric.min = min(geojson.features, feature => {
				return feature.properties[metric.id];
			});
			metric.max = max(geojson.features, feature => {
				return feature.properties[metric.id];
			});
			metric.mean = mean(geojson.features, feature => {
				return feature.properties[metric.id];
			});

			// metricGroups min/max:
			//	metricGroups.months.min = 7
			let group = metric.group.trim();
			if (group) {
				if (!metricGroups[group])
					metricGroups[group] = { min: metric.min, max: metric.max };
				else {
					metricGroups[group].min = Math.min(
						metricGroups[group].min,
						metric.min
					);
					metricGroups[group].max = Math.max(
						metricGroups[group].max,
						metric.max
					);
				}
			}
		});

		// set min/max for groupsed metrics and scale
		metricsCsv.forEach((metric, i) => {
			let group = metric.group.trim();
			if (group) {
				metric.min = metricGroups[group].min;
				metric.max = metricGroups[group].max;
			}

			// scales based on groups
			// move to previous loop for scales based on metric
			///////////////////////////////////////////

			// extent
			metric.extent =
				metric.direction == "d"
					? [metric.max, metric.min] // decending
					: [metric.min, metric.max]; // ascending

			// domain
			metric.domain = metric.range
				? metric.range.split("-").map(Number)
				: metric.extent;

			// %
			metric.scalePercent = scaleLinear()
				.domain([0, 1])
				.range(metric.domain);

			// color scales for metric
			metric.colorScale = scaleLinear()
				// .range(["green", "yellow", "red"])
				.range(["#1d4f6d", "#8f2e49", "#ff2230"])
				.unknown("#ccc")
				.domain([
					metric.scalePercent(0),
					metric.scalePercent(0.5),
					metric.scalePercent(1),
				]);
		});
	}
	// });
</script>

<style type="text/scss" global>
	@import "./style/global";
</style>

<!-- <svelte:options tag="cc-map" /> -->
<div class="cca__container" in:fade>
	{#if promise}
		{#await promise}
			<div class="cca__loading">
				<img alt="CCA" src="./assets/cca-logo.svg" />
				<h3>Loading...</h3>
			</div>
		{:then data}
			<div class="cca__header" in:fade>
				<Header />
			</div>
			<div class="cca__legend" in:fade>
				<Legend {geojson} />
			</div>
			<div class="cca__feature">
				<Feature />
			</div>
			<div class="cca__contents">
				<div class="cca__map" bind:clientWidth={mapW}>
					<Map {mapW} mapH={mapW * 0.58} {geojson} />
					<div class="cca__buttons">
						<Buttons />
					</div>
				</div>

				<div class="cca__metrics">
					<Metrics {metrics} />
				</div>
			</div>
			<div class="cca__sources">
				<Sources {sources} {version} />
			</div>
			<Tooltip />
		{:catch error}
			{error.message}!
		{/await}
	{/if}
</div>
